import {StatsByDataset} from "../../../../components/featureprint-stats/featureprint-stats.component";
import {Component, Input} from "@angular/core";

@Component({
  selector: 'default-fp-stats',
  templateUrl: './default-stats-view.component.html',
  styleUrls: ['./default-stats-view.component.scss']
})
export class DefaultStatsViewComponent {

  @Input() totals: StatsByDataset[] = [];

}

